
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { TestDetails } from "@/hooks/useTestCreator";
import { Briefcase } from "lucide-react";

interface BasicTestInfoProps {
  details: TestDetails;
  onChange: (details: TestDetails) => void;
}

export const BasicTestInfo = ({ details, onChange }: BasicTestInfoProps) => {
  return (
    <div className="space-y-6">
      <div className="w-full">
        <div className="space-y-2">
          <Label htmlFor="title" className="flex items-center gap-2">
            <Briefcase className="h-4 w-4" />
            Role Title
          </Label>
          <Input
            id="title"
            value={details.title}
            onChange={(e) => onChange({ ...details, title: e.target.value })}
            placeholder="Enter role title"
            className="bg-card"
          />
        </div>
      </div>
    </div>
  );
};
